import ReadingDataInfo from './ReadingDataInfo'

export default ReadingDataInfo
